function EllipseItem({ extraClass }) {
    return (<div className={`ellipse rounded-full absolute ${extraClass}`}></div>);
}
const Ellipse = () => <>
    <EllipseItem extraClass="left-top" />
    <EllipseItem extraClass="left-bottom" />
    <EllipseItem extraClass="right-middle" /></>
export default Ellipse;